// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import fetchBaseQuery from '@shared/utilities/fetchBaseQuery';
import { transformResponse } from '@utilities/api';
import { LoginResponse, LoginRequest, DeAuthResponse } from '@shared/types';

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery,
  endpoints: (builder) => ({
    /**
     * Login as user
     */
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: 'auth',
        method: 'POST',
        body: credentials,
      }),
      transformResponse,
    }),
    /**
     * DeAuth a user
     */
    logout: builder.mutation<DeAuthResponse, void>({
      query: () => ({
        url: 'deauth',
        method: 'POST',
      }),
      transformResponse,
    }),

    /**
     * Forgot password
     */
    forgotPassword: builder.mutation({
      query: (body) => ({
        url: 'forgot-password',
        method: 'POST',
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
} = authApi;
